window.lookupsUpdateCities = function(listenSelectComponent, updateSelectComponent) {
  var url = "/lookups/update_cities/"
  var updateComponent = $(updateSelectComponent);

  $(listenSelectComponent).on('change', function(event) {
    fetchData();
  });

  function fetchData() {
    var provinceId = $(listenSelectComponent + " option:selected").val();
    $.get(url + provinceId, function(data) {
      updateSelectComponentData(data);
    });
  }

  function updateSelectComponentData(data) {
    updateComponent.empty();
    $.each(data.cities, function(key,value) {
      updateComponent.append($("<option></option>")
        .attr("value", value.id).text(value.name));
    });
  }
}


window.lookupsUpdateJobPositions = function(listenSelectComponent, updateSelectComponent) {
  var url = "/lookups/update_job_positions/"
  var updateComponent = $(updateSelectComponent);

  $(listenSelectComponent).on('change', function(event) {
    fetchData();
  });

  function fetchData() {
    var orgId = $(listenSelectComponent + " option:selected").val();
    $.get(url + orgId, function(data) {
      updateSelectComponentData(data);
    });
  }

  function updateSelectComponentData(data) {
    updateComponent.empty();
    $.each(data.job_positions, function(key,value) {
      updateComponent.append($("<option></option>")
          .attr("value", value.id).text(value.name));
    });
  }
}

window.lookupEmployee = function(listenSelectComponent, updateSelectComponent) {
  var url = "/api/employees/by_organization_id/"
  var updateComponent = $(updateSelectComponent);

  $(listenSelectComponent).on('change', function(event) {
    fetchData();
  });

  function fetchData() {
    var orgId = $(listenSelectComponent + " option:selected").val();
    $.get(url + orgId, function(data) {
      updateSelectComponentData(data);
    });
  }

  function updateSelectComponentData(data) {
    updateComponent.empty();
    $.each(data.employees, function(key,value) {
      updateComponent.append($("<option></option>")
          .attr("value", value.id).text(value.full_name));
    });
  }
}
